import { axios } from '../http-common';

class Topup {

  request(data){
  	return axios.post("v1/member/topup/index",data);
  }
  list(data){
    return axios.get("v1/member/topup",{params: data});
  }
  load(data){
    return axios.get("v1/member/topup/load",{params: data});
  }
  uploadDocument(data){
    return axios.post("v1/member/deposit/topup/upload",data);
  }
  uploadPDF(data){
    return axios.post("v1/member/accounts/upload-pdf",data);
  }
    
}

export default new Topup();